<template lang="pug">
  div
    p.text-info ※ {{`1 ファイル につき ${$store.getState('attachment_max_size')} MB までのファイルをアップロードできます。`}}
    .form-group
      label 公開区分
      .radio.radio-rich
        label(data-testid="-radio-public")
          input#_bcard_card_input_public-1(type="radio", :value="app_flag.ON" name="openflag" v-model="openflag")
          span
            i.fa.fa-dot-circle-o.fa-lg
          i.fa.bcard-fa-person-public
          | &nbsp;公開
        |
        |
        label(data-testid="-radio-private")
          input#_bcard_card_input_public-0(type="radio", :value="app_flag.OFF" name="openflag" v-model="openflag")
          span
            i.fa.fa-dot-circle-o.fa-lg
          i.fa.bcard-fa-person-private
          | &nbsp;非公開
    .form-group
      label タイトル
        span.bcard-required (*)
      input.form-control(type="text" name="title" v-model="title", :maxlength="maxlengths.title" required data-testid="-input-file-title")
    .form-group
      label 添付ファイル
        span.bcard-required(v-if="!isEdit") (*)
      input#bcard-attach-files(type='file' name="files[]", :required="!isEdit" data-testid="-input-file-name")
    .form-group(v-if="isEdit")
      label アップロード済みファイル
      p.form-control-static
        a(href="#" @click.prevent="$emit('download', value)", :title="dispname" data-testid="-uploaded-file-name")
          | {{dispname}}
    .form-group
      p.bcard-required ※ (*)は必須項目です。
</template>

<script>
export default {
  name: 'AttachmentForm',
  props: {
    // 変更時の初期値
    value: {
      type: Object,
      required: false,
      default () {
        return {}
      }
    },
    isEdit: { type: Boolean, required: false, default: false }
  },
  data () {
    return {
      openflag: '1',
      title: '',
      dispname: '',
      mimetype: '',
      attach_url: '',
      maxlengths: {}
    }
  },
  watch: {
    value (data) {
      this.syncData(data)
    }
  },
  created () {
    this.maxlengths = this.loadMaxlengths('Attachments')
    this.syncData(this.value)
  },
  methods: {
    syncData (data) {
      this.openflag = data.openflag || this.app_flag.ON
      this.title = data.title || ''
      this.dispname = data.dispname || ''
      this.mimetype = data.mimetype || ''
      this.attach_url = data.attach_url || ''
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/organisms/forms/AttachmentForm.vue